import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { Mark, MarkUpsert } from "../../_objects/mark";
import { ApiService } from "../base/api-base.service";
import { MarkContractService } from "../interfaces/mark-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { MarkOfflineService } from "../offline/mark-offline.service";
import { MarkOnlineService } from "../online/mark-online.service";

@Injectable()
export class MarkService extends ApiService<MarkContractService> implements MarkContractService {
  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: MarkOfflineService,
    protected onlineService: MarkOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  // MK01 GET /api/v1/marks
  getMark(): Observable<Mark> {
    return this.service.getMark();
  }

  // MK02 PUT /api/v1/marks
  upsertMark(markUpsert: MarkUpsert): Observable<Mark> {
    return this.service.upsertMark(markUpsert);
  }
}
